import React, { useCallback } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import { AssetData } from '../AssetData';

import {
  spaceShape,
  termTranslationShape,
  sourceShape,
  questionShape
} from '../../../../../propsShape';

const AssetContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow: visible;
  height: 100%;
  flex: 1;
  min-height: 0;
`;

const StyledAssetData = styled(AssetData)`
  padding-bottom: 18px;
  overflow-x: hidden;
  overflow-y: auto;
  flex: 1;
  height: 100%;
  min-height: 0;
`;

/*
  This component manages loading / ready / error state of the asset answer
*/
const Asset = ({
  question,
  updateAnswer,
  addQuestionToSpace,
  removeQuestionFromSpace,
  handleCreateQuestion,
  handleDeleteQuestion,
  handleRetryQuestion,
  updateAssetTitle,
  createSpace,
  termTranslations,
  spaces,
  sources,
  isReadOnly,
  handleCreateAnswer,
  activeView,
  handleViewChange,
  activeChildQuestion,
  handleCollapseAsset = null,
  className = null,
  isEditSqlError,
  setIsEditSqlError
}) => {
  const navigate = useNavigate();

  const handleColumnOrderChange = useCallback((newColumnOrder, id) => {
    updateAnswer(id, { columnOrder: newColumnOrder });
  }, []);

  const childQuestion =
    activeChildQuestion !== null && question?.childQuestions
      ? question.childQuestions[activeChildQuestion]
      : null;

  return (
    <AssetContainer className={className}>
      <StyledAssetData
        handleCollapseAsset={handleCollapseAsset}
        question={childQuestion || question}
        isChildQuestion={childQuestion !== null}
        termTranslations={termTranslations}
        sources={sources}
        spaces={spaces}
        navigate={navigate}
        onCreateSpace={createSpace}
        onAddQuestionToSpace={addQuestionToSpace}
        onRemoveQuestionFromSpace={removeQuestionFromSpace}
        onColumnOrderChange={handleColumnOrderChange}
        onAssetTitleChange={updateAssetTitle}
        handleCreateQuestion={handleCreateQuestion}
        handleDeleteQuestion={handleDeleteQuestion}
        handleRetryQuestion={handleRetryQuestion}
        isReadOnly={isReadOnly}
        handleCreateAnswer={handleCreateAnswer}
        activeView={activeView}
        handleViewChange={handleViewChange}
        activeChildQuestion={activeChildQuestion}
        isEditSqlError={isEditSqlError}
        setIsEditSqlError={setIsEditSqlError}
      />
    </AssetContainer>
  );
};

Asset.propTypes = {
  spaces: PropTypes.arrayOf(spaceShape).isRequired,
  className: PropTypes.string,
  question: questionShape.isRequired,
  termTranslations: PropTypes.arrayOf(termTranslationShape).isRequired,
  sources: PropTypes.arrayOf(sourceShape),
  updateAnswer: PropTypes.func.isRequired,
  addQuestionToSpace: PropTypes.func.isRequired,
  removeQuestionFromSpace: PropTypes.func.isRequired,
  createSpace: PropTypes.func.isRequired,
  updateAssetTitle: PropTypes.func.isRequired,
  handleCreateQuestion: PropTypes.func.isRequired,
  handleDeleteQuestion: PropTypes.func.isRequired,
  handleRetryQuestion: PropTypes.func.isRequired,
  isReadOnly: PropTypes.bool.isRequired,
  handleCreateAnswer: PropTypes.func.isRequired,
  handleCollapseAsset: PropTypes.func,
  activeView: PropTypes.oneOf(['table', 'source', 'chart']).isRequired,
  handleViewChange: PropTypes.func.isRequired,
  activeChildQuestion: PropTypes.number.isRequired,
  isEditSqlError: PropTypes.bool.isRequired,
  setIsEditSqlError: PropTypes.func.isRequired
};

export { Asset };
